import React, { useContext } from 'react';
import { Can as CaslCan } from '@casl/react';
import { UserPolicyContext } from './UserPolicyContext';

export function Can(props) {
  const context = useContext(UserPolicyContext);
  const ability = context?.userAccount?.ability;

  return (
    <CaslCan
      ability={ability}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
